define('PartLookupSearcher.Collection', [
	'Item.Collection',
	'Profile.Model',

	'Session',
	'Utils',
	'underscore',
], function (
  ItemCollection,
  ProfileModel,

  Session,
  Utils,
  _,
) {

	'use strict';
  
  return ItemCollection.extend({

    url: function() {
			return Utils.getAbsoluteUrl(
				getExtensionAssetsPath(
					'Modules/PartLookupSearcher/SuiteScript2/PartLookupSearcher.Service.ss'
				),
				true
			);

    },
    
    defaultOptions: {
      searcherAPIConfiguration: 'modelsearch'
    },
    
    initialize: function(collection, options) {
      this.options = _.defaults(options || {}, this.defaultOptions);
      
      this.searchApiMasterOptions = {
        fieldset: 'modelsearch',
        include: ''
      }
      debugger;
      ItemCollection.prototype.initialize.apply(this, arguments);

    },
    
    fetch: function(options) {
      options = options || {};
      options.cache = true;
      return ItemCollection.prototype.fetch.apply(this, arguments);
    }
  });
});


      // var profile = ProfileModel.getInstance();
      // var url = Utils.addParamsToUrl(
      //   profile.getSearchApiUrl(),
      //   _.extend(
      //     {},
      //     this.searchApiMasterOptions,
      //     Session.getSearchApiParams()
      //   ), profile.isAvoidingDoubleRedirect()
      // );
